import { render, staticRenderFns } from "./FertilizerStatistics.vue?vue&type=template&id=881c3104&"
import script from "./FertilizerStatistics.vue?vue&type=script&lang=js&"
export * from "./FertilizerStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports